import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Redirect old /create-event to the new wizard at /create (preserves
// ?source + ?source_event_id for growth-loop attribution)
const CreateEvent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    navigate(`/create${location.search}`, { replace: true });
  }, [navigate, location.search]);
  return null;
};

export default CreateEvent;
